import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['fi', 'en'],
  // Used when no locale matches
  defaultLocale: 'fi',

  pathnames: {
    '/': {
      fi: '/',
      en: '/',
    },
    '/yhteystiedot': {
      en: '/contact',
      fi: '/yhteystiedot',
    },
    '/rekrytointi': {
      en: '/recruitment',
      fi: '/rekrytointi',
    },
    '/rekrytointi/lomake': {
      en: '/recruitment/form',
      fi: '/rekrytointi/lomake',
    },
    '/palvelut': {
      en: '/services',
      fi: '/palvelut',
    },
    '/palvelut/ammatillinen-tukihenkilotyo': {
      en: '/services/professional-support-services',
      fi: '/palvelut/ammatillinen-tukihenkilotyo',
    },
    '/palvelut/tehostettu-perhetyo': {
      en: '/services/enhanced-family-support',
      fi: '/palvelut/tehostettu-perhetyo',
    },
    '/palvelut/perhetyo': {
      en: '/services/family-work',
      fi: '/palvelut/perhetyo',
    },
    '/tarinamme': {
      fi: '/tarinamme',
      en: '/our-story',
    },
    '/tietosuojaseloste': {
      fi: '/tietosuojaseloste',
      en: '/privacy-policy',
    }
  }
});

